<template>
  <div :class="[`alert`, {
    'shadow-xl': shadow,
    'alert-default': type === 'default',
    'alert-success': type === 'success',
    'alert-info': type === 'info',
    'alert-error': type === 'error',
    'alert-warning': type === 'warning',
    }]">
    <div class="w-full flex justify-center">
      <my-button v-if="loading" disabled type="ghost" :loading="true" square></my-button>
      <hero-icon v-if="icon" :name="icon"></hero-icon>
      <span class="flex-1"><slot /></span>
      <my-button v-if="closable" size="small" square icon="x-circle" type="ghost" @click="$emit('close')" />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    loading: { type: Boolean, default: false },
    shadow: { type: Boolean, default: false },
    type: { type: String, default: 'default' },
    closable: { type: Boolean, default: false }
  },
  computed: {
    icon () {
      if (this.type === 'error') {
        return 'minus-circle'
      } else if (this.type === 'warning') {
        return 'information-circle'
      } else if (this.type === 'success') {
        return 'check-circle'
      }
      return null
    }
  }
}
</script>
